import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { resources } from '@ousse/shared/i18n'
import { DEFAULT_LOCALE, LOCALES } from '@ousse/shared'

/** Traductions partagées (packages/shared). Langue : profil de l'utilisateur, sinon celle du navigateur. */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...LOCALES],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    showSupportNotice: false,
    detection: { order: ['navigator'], caches: [] },
  })

const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng.slice(0, 2)
}
syncHtmlLang(i18n.language ?? DEFAULT_LOCALE)
i18n.on('languageChanged', syncHtmlLang)

export default i18n
